/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExternalDocument,
    ExternalDocumentFromJSON,
    ExternalDocumentFromJSONTyped,
    ExternalDocumentToJSON,
    ExternalPartners,
    ExternalPartnersFromJSON,
    ExternalPartnersFromJSONTyped,
    ExternalPartnersToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExternalDocumentIEnumerableExternalPartnerResponse
 */
export interface ExternalDocumentIEnumerableExternalPartnerResponse {
    /**
     * 
     * @type {ExternalPartners}
     * @memberof ExternalDocumentIEnumerableExternalPartnerResponse
     */
    partner?: ExternalPartners;
    /**
     * 
     * @type {number}
     * @memberof ExternalDocumentIEnumerableExternalPartnerResponse
     */
    responseCode?: number;
    /**
     * 
     * @type {Array<ExternalDocument>}
     * @memberof ExternalDocumentIEnumerableExternalPartnerResponse
     */
    data?: Array<ExternalDocument> | null;
}

export function ExternalDocumentIEnumerableExternalPartnerResponseFromJSON(json: any): ExternalDocumentIEnumerableExternalPartnerResponse {
    return ExternalDocumentIEnumerableExternalPartnerResponseFromJSONTyped(json, false);
}

export function ExternalDocumentIEnumerableExternalPartnerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalDocumentIEnumerableExternalPartnerResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partner': !exists(json, 'partner') ? undefined : ExternalPartnersFromJSON(json['partner']),
        'responseCode': !exists(json, 'responseCode') ? undefined : json['responseCode'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(ExternalDocumentFromJSON)),
    };
}

export function ExternalDocumentIEnumerableExternalPartnerResponseToJSON(value?: ExternalDocumentIEnumerableExternalPartnerResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partner': ExternalPartnersToJSON(value.partner),
        'responseCode': value.responseCode,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(ExternalDocumentToJSON)),
    };
}


